<div class="litmus-seprator-container">
    <div *ngIf="!isNameSeprator" class="litmus-seprator"></div>
    <div *ngIf="isNameSeprator" class="litmus-seprator-with-name">
        <div class="left-seprator"></div>
        <div class="seprator-header">{{text}}</div>
        <div class="right-seprator"></div>
    </div>
</div> 